import { AutoComplete } from 'antd';
import type { AutoCompleteProps } from 'antd';

export interface DAutoCompleteProps extends AutoCompleteProps {}

export const DarwinAutoComplete = (props: DAutoCompleteProps) => {
  return <AutoComplete {...props} />;
};
